<!-- //
组件右侧属性配置的包装视图
@auth xuyd
@date 2024-05-02
//-->
<template>
  <el-tabs v-model="formData.selectedTab" type="border-card" style="height: 100%;">
    <el-tab-pane label="视图样式" name="1" style="height: 100%;" v-if="hasViewStyleTab">
      <el-scrollbar class="scroll-container">
        <WidgetVersion :version-props="formData.versionProps"/>
        <BlockDivider/>
        <WidgetPosition :viewProps="formData.viewProps" style="padding-bottom: 5px;"/>
        <BlockDivider/>
        <slot />
      </el-scrollbar>
    </el-tab-pane>

    <el-tab-pane label="数据源" name="2" style="height: 100%;" v-if="hasDatasourceTab">
      <el-scrollbar class="scroll-container">
        <WidgetVersion :version-props="formData.versionProps"/>
        <BlockDivider/>
        <DvPropsDatasource :widgetProps="formData"/>
      </el-scrollbar>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import WidgetPosition from './widget-position'
import WidgetVersion from './widget-version'
import DvPropsDatasource from './DvPropsDatasource'

export default {
  name: 'PropsWrapper',
  components: {
    WidgetPosition,
    WidgetVersion,
    DvPropsDatasource,
  },
  data() {
    return {
      formData: this.widgetProps,
    }
  },
  props: {
    hasViewStyleTab: {
      type: Boolean,
      default: true
    },
    hasDatasourceTab: {
      type: Boolean,
      default: true
    },
    tabs: {
      type: Array,
      default: () => {
        return ['视图样式','数据源']
      }
    },
    widgetProps: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    widgetProps: {
      handler: function (val) {
        console.log(`---------watch ${this.$options._componentTag} widgetProps-------->`);
        this.formData = val;
      },
      immediate: false
    }
  },
}
</script>

<style scoped lang="less">

.scroll-container {
  height: 100%;
}

.scroll-container .el-scrollbar__wrap {
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>
